export default {
  header: "My About Page",
  view: "About"
};
